import { render, staticRenderFns } from "./SchoolTeacherEmployeeApplication.vue?vue&type=template&id=d960cb12&scoped=true&"
import script from "./SchoolTeacherEmployeeApplication.vue?vue&type=script&lang=js&"
export * from "./SchoolTeacherEmployeeApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d960cb12",
  null
  
)

export default component.exports